import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-login-layout',
  standalone: true,
  imports: [RouterOutlet, FormsModule, ReactiveFormsModule],
  template: `
    <router-outlet></router-outlet>
  `,
  styleUrl: './loginlayout.component.scss'
})
export class LoginLayoutComponent {}
